{
    "send_email__title": "Beleg via Email an Kunden versenden?",
    "send_email__body": "Dies versendet eine Email mit Standardformulierung und Beleg als PDF im Anhang. Die Email wird von deinem Postfach an den hinterlegten Kontakt gesendet.",

    "toast_confirm_email__title": "Beleg erfolgreich via Email versendet",
    "toast_confirm_email__body": "Er ist nun auch in Enventa einsehbar",

    "delete_order__title": "Auftrag abbrechen?",
    "delete_order__body": "Der Auftrag wird nicht gespeichert. Dies kann nicht rückgängig gemacht werden.",

    "toast_confirm_delete_order__title": "Auftrag gelöscht",
    "toast_confirm_delete_order__body": "Der Auftrag wurde erfolgreich gelöscht",

    "delete_quote__title": "Angebot abbrechen?",
    "delete_quote__body": "Das Angebot wird nicht gespeichert. Dies kann nicht rückgängig gemacht werden.",

    "toast_confirm_delete_quote__title": "Angebot gelöscht",
    "toast_confirm_delete_quote__body": "Das Angebot wurde erfolgreich gelöscht",

    "action__submit_without_email": "keine Email versenden",
    "action__submit_with_email": "Email versenden"
}
